export const GACategories = {
  assessment: 'Assessment',
  auth: 'Auth',
  error: 'Error',
  interview: 'Interview',
};

export const GAActions = {
  switchTab: 'switch_tab',
  toggleEditor: 'toggle_editor',
  solveQuestion: 'solve_or_reattempt',
  testCode: 'test_code',
  runCode: 'run_code',
  submitTest: 'submit_test',
  startTest: 'start_test',
  resumeTest: 'resume_test',
  javascriptError: 'javascript_error',
  googleLogin: 'google_login',
  submitSection: 'submit_section',
  endInterview: 'end_interview',
};

export const GALabels = {
  Results: 'results',
  'Problem Statement': 'problem_statement',
  'Custom Input': 'custom_input',
  c: 'c',
  java: 'java',
  python3: 'python3',
};
